/*
 * Revamped article — open in-copy links in a new tab.
 *
 * The links inside the article body live in rich-text metafields and are
 * rendered by Liquid's `metafield_tag`, which emits a plain <a href> and
 * ignores a `target` set on the rich-text link node (tested — the attribute
 * is accepted by the Admin API but never reaches the markup). So the only
 * place to set it is here.
 *
 * Links written directly in the section templates already carry target and
 * rel, so this is a no-op for them.
 *
 * Skipped: the table of contents and anything else pointing at an in-page
 * anchor, which must stay in the same tab to work at all.
 */
document.addEventListener('DOMContentLoaded', function () {
  const article = document.querySelector('.rv-article, .rv-body');
  if (!article) return;

  document.querySelectorAll('.rv-article a[href]').forEach(function (link) {
    const href = link.getAttribute('href') || '';

    // In-page jumps, mailto/tel and anything already handled are left alone.
    if (href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
    if (link.closest('.rv-toc')) return;
    if (link.target === '_blank') return;

    link.target = '_blank';
    link.rel = link.rel ? link.rel + ' noopener' : 'noopener';
  });
});
